<template>
    <div class="custom-error-message" v-bind:style="{height}">
      <h3>{{message}}</h3>
    </div>
</template>

<script>
import {EventBus} from '@/services/EventBus';

export default {
  props: ['message'],
  data() {
    return {
      height: null
    };
  },
  mounted() {
    window.addEventListener('resize', this.resize);
    this.resize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
  },
  methods: {
    resize() {
      let frame = window.frameElement || this.$root.$el;
      let iframeWidth = frame.offsetWidth;
      let iframeHeight = Math.floor((iframeWidth * 9) / 16);
      if (window.frameElement) {
        frame.style.height = iframeHeight + 'px';
      } else {
        EventBus.$emit('heightChange', iframeHeight);
      }
      this.height = iframeHeight + 'px';
    },
    disable() {
      this.$store.commit('disablePosterMode');
      this.$emit('disabled');
      if (!window.frameElement) {
        this.$root.$el.style.height = 'auto'
      }
    }
  }
};
</script>

<style lang='scss'>
    .custom-error-message {
        background-color: black;
        text-align: center;
        display: flex;
        align-items: center;
        color: white;
        flex-direction: column;
        justify-content: center;

        font-family: Rubik, Arial, Helvetica, sans-serif !important
    }
</style>
